import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

export const XRoutesContainer = ({
  defaultRoute,
  notFountPage,
  children,
}: {
  defaultRoute: string;
  notFountPage: React.ReactElement;
  children: React.ReactElement;
}) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to={defaultRoute} />} />
        {children}
        <Route path="*" element={notFountPage} />
      </Routes>
    </BrowserRouter>
  );
};
